import { FC, CSSProperties } from 'react';
import Spin from 'components/Spin';
import { QRCodeCanvas } from 'qrcode.react';

interface IProps {
  loading?: boolean;
  value: string;
  size?: number;
  level?: 'L' | 'M' | 'Q' | 'H';
  padding?: number;
  style?: Omit<CSSProperties, "width" | "height" | "padding">;
}

const QrCode: FC<IProps> = ({
  loading = false,
  value,
  size,
  level = 'M',
  padding = 4,
  style = {}
}) => {

  const default_size = 192;

  const _size = size || default_size;

  const containerStyle: CSSProperties = {
    backgroundColor: "#fff",
    borderRadius: 12,
    overflow: 'hidden',
    width: _size,
    height: _size,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    ...style
  }

  return (
    <div style={containerStyle}>
      {
        loading ? <Spin size="large" /> : (
          value &&
          <QRCodeCanvas
            value={value}
            size={_size}
            level={level}
            marginSize={padding}
          />
        )
      }
    </div>
  )
}

export default QrCode;

